import { useEffect, useMemo } from 'react';

import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';

import { COHORT3_CONSOLIDATION_BANNER } from '../common/constants.tsx';
import { useCohort3CustomerBannerActions, useCohort3CustomerBannerState } from './store/index.tsx';

export const useCohort3CustomersBanner = () => {
	const isAdmin = useIsAdmin();
	const isSiteAdmin = useIsSiteAdmin();
	const accountId: AccountId | null = useAccountId();
	const { isDismissed, height } = useCohort3CustomerBannerState();
	const { fetchBannerVisibility } = useCohort3CustomerBannerActions();

	useEffect(() => {
		if (!accountId) {
			return;
		}

		fetchBannerVisibility(accountId);
	}, [accountId, fetchBannerVisibility]);

	return useMemo(
		() => ({
			isEnabled: Boolean((isAdmin || isSiteAdmin) && !isDismissed),
			name: COHORT3_CONSOLIDATION_BANNER,
			height,
		}),
		[isAdmin, isSiteAdmin, isDismissed, height],
	);
};
